import React from 'react';
import { Translate } from 'react-localize-redux';
import styled from 'styled-components';

const Container = styled.div`
  background: white;
  margin: 1rem 0 0 0;
  display: flex;
  justify-content: center;
  position: relative;
  z-index: 1;
`;

const Title = styled.p`
  color: red;
  cursor: default;
  font-size: 0.7rem;
  font-weight: bold;
  margin: 1.25em 0;
  padding: 0 1em;
  transition: filter 0.25s;

  &:hover {
    filter: brightness(1.25);
  }

  @media (min-width: 375px) {
    font-size: 0.84rem;
  }

  @media (min-width: 768px) {
    font-size: 1rem;
  }
`;

const ImportantNotification = () => {
  return (
    <Container>
      <Title>
        <Translate id="psyLandingPage.importantNotice.title" />
      </Title>
    </Container>
  );
};

export default ImportantNotification;
